<template>
  <div class="sidebar-layout-heading" :class="{ [extraClass]: !!extraClass }">
    <span class="sidebar-layout-heading__title">
      {{ title }}
      <slot></slot>
    </span>
    <div class="sidebar-layout-heading__buttons-wrapper" v-if="buttons">
      <template v-for="btn in buttons">
        <component
          v-if="btn.component"
          :is="btn.component"
          :key="btn.key"
          v-bind="btn.props"
        ></component>
        <v-button v-else v-bind="btn" :key="btn.key"></v-button>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import VButton, { ButtonTypes } from "@/components/VButton";

export default Vue.component("VSidebarLayoutHeading", {
  props: {
    title: VueTypes.string,
    buttons: VueTypes.any,
    extraClass: VueTypes.string.def("")
  },

  components: {
    VButton
  }
});
</script>

<style lang="scss" scoped>
$ns: "sidebar-layout-heading";

.#{$ns} {
  padding-right: 15px;
  margin-bottom: $general-padding;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: $input-height;

  &__title {
    display: flex;
    align-items: center;
    font-size: 22px;
    color: $primary-text-color;
    margin-right: 40px;
    font-family: "Lato-Regular", Arial, sans-serif;
    font-weight: 400;
    /*margin-top: 3px;*/
  }

  button {
    margin-right: 30px;

    &:last-child {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 991px) {
  .#{$ns} {
    align-items: flex-start;

    .#{$ns}__buttons-wrapper {
      display: flex;

      button {
        margin-bottom: 15px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .#{$ns}__title {
    margin-right: 0;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 600px) {
  .#{$ns} {
    flex-direction: column;
    align-items: center;
  }
}
</style>
